import * as Types from '../../../../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetGuestsiteFaqQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  isAdminDashboard?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type GetGuestsiteFaqQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: { __typename?: 'EventInfo'; id: string; faq: Array<{ __typename?: 'EventQanda'; id: string; type: Types.QandaType; question: string; answer: string }> };
  } | null;
};

export const GetGuestsiteFaqDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGuestsiteFaq' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isAdminDashboard' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isAdminDashboard' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'faq' },
                        name: { kind: 'Name', value: 'qanda' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'EnumValue', value: 'faq' } }],
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventQanda' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventQanda' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventQanda' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'question' } },
          { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetGuestsiteFaqQuery__
 *
 * To run a query within a React component, call `useGetGuestsiteFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestsiteFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestsiteFaqQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      isAdminDashboard: // value for 'isAdminDashboard'
 *   },
 * });
 */
export function useGetGuestsiteFaqQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>) {
  return ApolloReactHooks.useQuery<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>(GetGuestsiteFaqDocument, baseOptions);
}
export function useGetGuestsiteFaqLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>(GetGuestsiteFaqDocument, baseOptions);
}
export type GetGuestsiteFaqQueryHookResult = ReturnType<typeof useGetGuestsiteFaqQuery>;
export type GetGuestsiteFaqLazyQueryHookResult = ReturnType<typeof useGetGuestsiteFaqLazyQuery>;
export type GetGuestsiteFaqQueryResult = Apollo.QueryResult<GetGuestsiteFaqQuery, GetGuestsiteFaqQueryVariables>;
